import apiClient from './apiClient';
import userManager from '../auth/authService';

let interceptorId = null;

export function setupApiInterceptors(visitorId) {

    if (interceptorId !== null) {
        apiClient.interceptors.request.eject(interceptorId);
        interceptorId = null;
    }
    
    apiClient.interceptors.request.use(async config => {
        if (!config.headers) config.headers = {};

        if (visitorId) {
            config.headers['X-User-Fingerprint'] = visitorId;
        }

        let u = await userManager.getUser();
        if (u && u.expired) {
            try {
                u = await userManager.signinSilent();
                console.log("Silent renew successful", u);
            } catch (err) {
                console.error("Silent renew failed", err);
            }
        }

        if (u && u.access_token) {
            config.headers['Authorization'] = `Bearer ${u.access_token}`;
        }

        // if (u && u.profile?.sub) {
        //     config.headers['X-User-OpenId'] = u.profile.sub;
        // }

        return config;
    });
}